/** 每个标签栏独占；StrictMode重新挂载只启用新输入，不复活已销毁的资源。 */
export class TabDragScope {
  active = false;
  private cleanups = new Set<() => void>();

  activate() {
    this.active = true;
  }

  own(cleanup: () => void) {
    if (!this.active) {
      cleanup();
      return () => {};
    }
    this.cleanups.add(cleanup);
    return () => {
      this.cleanups.delete(cleanup);
    };
  }

  dispose() {
    this.active = false;
    for (const cleanup of [...this.cleanups]) cleanup();
    this.cleanups.clear();
  }
}

/** 同时管理输入期间和松手后短暂click抑制期间的资源。 */
export class InputResources {
  private closed = false;
  private cleanups = new Set<() => void>();
  private unregister: () => void = () => {};

  constructor(scope: TabDragScope) {
    this.unregister = scope.own(() => this.dispose());
  }

  add(cleanup: () => void) {
    if (this.closed) cleanup();
    else this.cleanups.add(cleanup);
  }

  listen<K extends keyof DocumentEventMap>(
    target: EventTarget,
    type: K,
    callback: (event: DocumentEventMap[K]) => void,
    options?: AddEventListenerOptions,
  ) {
    if (this.closed) return;
    const listener: EventListener = (event) => {
      if (!this.closed) callback(event as DocumentEventMap[K]);
    };
    target.addEventListener(type, listener, options);
    this.add(() => target.removeEventListener(type, listener, options));
  }

  defer(callback: () => void, delay: number) {
    if (this.closed) return;
    const timer = setTimeout(() => {
      this.cleanups.delete(cancel);
      if (!this.closed) callback();
    }, delay);
    const cancel = () => clearTimeout(timer);
    this.add(cancel);
  }

  dispose() {
    if (this.closed) return;
    this.closed = true;
    for (const cleanup of this.cleanups) cleanup();
    this.cleanups.clear();
    this.unregister();
  }
}
